<template>
  <div class="create-h">
    <div class="create_hed">
      <div class="create_header">Chatbots</div>
      <!-- <router-link class="create-btn_link btn-static" to="/user/create_bot">
            <ButtonWithLoadWebsite
              title="+ Create new Chatbot"
              class="website_btn"
              :shaked="true"
            />
          </router-link> -->
    </div>
    <div class="create">
      <img class="create_img" src="@/assets/img/create_bot_img.png" alt="" />
      <div class="create_title">
          <span class="">
            {{ 
              userWidgets?.length === 0 ? 
              'You do not have any bots created yet.' : 
              'Need new chatbot?'
            }}
          </span>
          <br>
          {{ 
            userWidgets?.length === 0 ?
            'Create your first bot by clicking on the "Create New Chatbot" button' :
            'You can create one more by clicking on the "Create New Chatbot" button' 
          }}
        <div class="chatbots_arrow_wrapper">
          <!-- <img class="chatbots_arrow_left" src="../assets/img/chatbots_arrow_left.png" />
          <img class="chatbots_arrow_bottom" src="../assets/img/chatbots_arrow_bottom.png" /> -->
        </div>
      </div>
      <!-- <router-link class="create-btn_link btn-absolute" to="/user/create_bot"> -->
      <ButtonWithLoadWebsite
        @onClick="sendAnalyticEvent"      
        title="+ Create new Chatbot"
        class="website_btn"
        :shaked="true"
      />
      <!-- </router-link> -->
    </div>
  </div>
</template>

<script>
import ButtonWithLoadWebsite from "../components/shared/ButtonWithLoadWebsite.vue";
import store from "../vuex/store";

export default {
  components: {
    ButtonWithLoadWebsite,
  },
  computed: {
    userWidgets() {
      return store?.state?.users?.widgets || [];
    },
    subscriptionData() {
      return store?.state?.users?.chosenWidget?.owner?.subscription;
    },
  },
  methods: {
    sendAnalyticEvent() {
      if ((!this.subscriptionData && !this.userWidgets.length) || (this.subscriptionData && this.subscriptionData?.bots_available - this.userWidgets.length > 0)) {
        this.$router.push("/user/create_bot");
        gtag('event', 'create_new_chatbot_click', {});
        amplitude.getInstance().logEvent('create_new_chatbot_click', {});
      } else {
        this.$toast.warning("To create an additional chatbot, upgrade your plan");
      }      
    }
  }
}
</script>

<style scoped lang="scss">
.website_btn {
  font-size: 20px;
  padding: 10px 22px;
}
.create {
  /* padding-top: 162px; */
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 37px;
  height: calc(100% - 162px);
  justify-content: center;
}
.create_title {
  max-width: 302px;
  width: 100%;
  text-align: center;
  color: #828282;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.chatbots_arrow_wrapper {
  position: relative;
}

.create-btn_link {
  // position: absolute;
  // top: -245px;
  // right: -360px;

  // @media (max-width: 1399px), (max-height: 824px) {
  //   display: none;
  // }

  // &.btn-static {
  //   position: static;
  //   display: block;

  //   @media (min-width: 1400px) and (min-height: 825px) {
  //     display: none;
  //   }
  // }
}


.chatbots_arrow_bottom {

}

.chatbots_arrow_left {
  display: block;
  /* width: 320px;
  height: 305px; */
  position: absolute;
  bottom: 11px;
  right: -66%;

  @media (max-width: 1399px), (max-height: 824px) {
    display: none;
  }
}

.create_img {
  width: 314px;
}
.create_title span {
  color: #828282;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}
.create_header {
  color: #212b36;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
}
.create_hed {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 48px 48px 0 48px;
}
.create-h {
  height: calc(100% - 82px);
}
</style>
